export default __webpack_public_path__ + "static/media/city.202db3d8.png";